export default "/_next/static/src/assets/videos/6bfe7851ac7e12dd9e9cd51dcf4adc21.mp4";